import NavigationBar from "../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../navigation/footer/footerComponent";
import FoundersBody from "./foundersBody";

export default function MainFounders(props) {

    return (
        <div>
            <NavigationBar />
            <FoundersBody />
            <FooterComponent />
        </div>
    )
}